const working_data=[
    {id:11,jobname:"principal",jobstatus:"work in progress"},
    {id:12,jobname:"teacher",jobstatus:"work in progress"},
    {id:13,jobname:"helper",jobstatus:"work in progress"},
    {id:14,jobname:"magistarde",jobstatus:"work in progress"}
]

export default working_data;